module.exports = __webpack_public_path__ + "img/mobile_v2.26542173.svg";